import { COLOR, FONT_SIZE, Heading as _Heading, mq } from "@dmm-com/rocket-web-ui-library";

import styled from "@emotion/styled";

export const HeadingSeasonTitle = styled(_Heading)`
  max-width: 672px;
  width: calc(100% - 32px);
  font-size: ${FONT_SIZE.LL}px;
  ${mq.sp} {
    width: calc(100% - 40px);
    font-size: ${FONT_SIZE.L}px;
  }
`;

export const ParSeasonName = styled.p`
  font-size: ${FONT_SIZE.M}px;
  color: ${COLOR.GRAY500.code};
  margin-top: 8px;

  ${mq.sp} {
    margin-top: 4px;
    font-size: ${FONT_SIZE.S}px;
  }
`;
